import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './App.css';
import ArticlePage from './components/pages/ArticlePage';
import HomePage from './components/pages/HomePage';
import MissionPage from './components/pages/MissionPage';
import Layout from './components/Layout';
import { HelmetProvider } from 'react-helmet-async';
import ArticlesListPage from "./components/pages/ArticlesListPage";
import ContactPage from "./components/pages/ContactPage";
import PrivacyPage from "./components/pages/PrivacyPage";
import TermsPage from "./components/pages/TermsPage";


function LanguageRouterWrapper() {
  const location = useLocation();
  const navigate = useNavigate();
  const { i18n } = useTranslation();
  const params = useParams();
  const lng = params.lng;

  useEffect(() => {
    if (lng && i18n.language !== lng) {
      i18n.changeLanguage(lng);
    }
    // Se la lingua non è presente nella url, reindirizza a quella attuale
    if (!lng) {
      navigate(`/${i18n.language}${location.pathname}`, { replace: true });
    }
    // eslint-disable-next-line
  }, [lng, i18n, location.pathname]);

  return (
    <Layout language={lng} key={lng}>
      <Routes>
        <Route path="/" element={<HomePage language={lng} key={lng} />} />
        <Route path="articles" element={<ArticlesListPage language={lng} key={lng} />} />
        <Route path="article/:slugId" element={<ArticlePage language={lng} key={lng} />} />
        <Route path="mission" element={<MissionPage />} />
        <Route path="contact" element={<ContactPage />} />
        <Route path="privacy" element={<PrivacyPage />} />
        <Route path="terms" element={<TermsPage />} />
      </Routes>
    </Layout>
  );
}

function App() {
  return (
      <HelmetProvider>
        <Router>
          <Routes>
            <Route path="/:lng/*" element={<LanguageRouterWrapper />} />
            {/* Redirect root to default language */}
            <Route path="/*" element={<LanguageRouterWrapper />} />
          </Routes>
        </Router>
      </HelmetProvider>
  );
}

export default App;
